import { HttpClient } from "@/App/services/HttpClient";
import { Truck } from "@/TruckSelection/models/Truck";
import { TRUCKS_ENDPOINTS } from "@/TruckSelection/config";

export const TrucksService = {
  async getData(emsAgencyId: String): Promise<Array<Truck>> {
    return await HttpClient.get(TRUCKS_ENDPOINTS.GET(emsAgencyId));
  },
};
